







































































































































































































































import { defineComponent, onMounted, ref, watch } from '@nuxtjs/composition-api';
import { useAbandonedCart, useCartAttributes, useCartCrossProducts, useSetOrderSourceOnCart } from '~/features/cart';
import { useSeoMeta } from '~/features/seo';
import { useRouter } from '~/features/router';
import { useAuth } from '~/features/auth';
import { useStoreConfig } from '~/features/storeConfig';
import { copyToClipboard } from '~/utils/text';
import { useAlerts } from '~/features/alerts';
import { useI18n } from '~/features/i18n';

export default defineComponent({
  setup() {
    const activeEventType = ref<'SPIN_THE_WHEEL' | 'MEMORY_GAME'>('SPIN_THE_WHEEL');

    const {
      count,
      items,
      discounts,
      cartGifts,
      subtotal,
      hasInvalidItems,
      cartId,
      spinTheWheelData,
      cartPromotions,
      cartPriceRuleDiscounts,
      isFetchingCart,
    } = useCartAttributes();

    useAbandonedCart();
    const { items: suggestedProducts } = useCartCrossProducts();
    const { setOrderSourceOnCart } = useSetOrderSourceOnCart();
    const { cartConfigurableMessage, cartCouponCode } = useStoreConfig();
    const { success } = useAlerts();
    const { t } = useI18n();

    const { lastRoute } = useRouter();
    const { isLoggedIn } = useAuth();

    function isSpinningWheelGift(sku: string) {
      return spinTheWheelData.value?.gift && spinTheWheelData.value.gift?.sku === sku;
    }

    function setSource() {
      // Detect if this is a pwa and if so which operating system
      const isPwa =
        process.browser &&
        (('standalone' in window.navigator && (window.navigator as any).standalone) ||
          window.matchMedia('(display-mode: standalone)').matches ||
          window.matchMedia('(display-mode: fullscreen)').matches);

      if (isPwa) {
        const isIos = window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
        const isAndroid = window.navigator.userAgent.match(/Android/i);

        if (isIos) {
          setOrderSourceOnCart('iOS');
        } else if (isAndroid) {
          setOrderSourceOnCart('Android');
        }
        return;
      }
      setOrderSourceOnCart('Web');
    }

    function copyCode(value: string) {
      copyToClipboard(value);
      success(t('codeCopied').toString());
    }

    // When user logs in set on customer cart
    watch(cartId, () => {
      setSource();
    });

    onMounted(() => {
      // Ignore if there are no items in the cart
      // Or if last route was already cart to handle login redirection
      if (!count.value || /cart/.test(lastRoute as string)) {
        return;
      }

      setSource();
    });

    useSeoMeta({
      title: 'My Cart',
      description: 'Review your cart items before checking out',
    });

    return {
      copyCode,
      count,
      items,
      cartGifts,
      discounts,
      suggestedProducts,
      subtotal,
      hasInvalidItems,
      isLoggedIn,
      cartPromotions,
      spinTheWheelData,
      cartPriceRuleDiscounts,
      activeEventType,
      isSpinningWheelGift,
      cartConfigurableMessage,
      cartCouponCode,
      isFetchingCart,
    };
  },
  head: {},
});
